import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React, { FC } from 'react';
import { getBackgroundColor, getResponsiveType } from '../../utils';
import { Typography } from '../typography';

export interface TagProps {
  label: string;
  inversed?: boolean;
}

interface StyledTagProps {
  inversed?: boolean;
}

export const StyledTag = styled(Typography)<StyledTagProps>`
  ${({ theme: { space, borderRadii }, inversed }) => css`
    padding: ${space.xxSmall} ${space.xSmall};
    border-radius: ${borderRadii.small};
    display: inline-flex;
    ${getResponsiveType('caps')}
    ${getBackgroundColor(inversed ? 'neutralWhite' : 'brandTwo100')}
  `};
`;

export const Tag: FC<TagProps> = ({ label, inversed, ...rest }) => (
  <StyledTag component="span" variant="caps" inversed={inversed} {...rest}>
    {label}
  </StyledTag>
);

export default Tag;
